import React from "react";
import PropTypes from "prop-types";
import FormattedQuantity from "../common/FormattedQuantity";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "../common/tables";
import { SubscriptionLevelLabel as FormattedSubscriptionLevel } from "../../../common/SubscriptionLevelLabel";
import { SUBSCRIPTION_LEVEL } from "../../../../constant/subscriptionLevel";

const Summary = ({ className, rows }) => {
  return (
    <TableContainer className={className}>
      <Table>
        <TableBody>
          {rows && rows.map(row => (
            <TableRow key={row.subscriptionLevel}>
              <TableCell>
                <FormattedSubscriptionLevel
                  subscriptionLevel={row.subscriptionLevel}
                />
              </TableCell>
              <TableCell
                align="right"
                style={{ whiteSpace: "nowrap", verticalAlign: "top" }}
              >
                <FormattedQuantity quantity={row.quantity} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

Summary.defaultProps = {
  className: {},
  rows: [],
};

Summary.propTypes = {
  className: PropTypes.string,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      subscriptionLevel: PropTypes.oneOf(Object.values(SUBSCRIPTION_LEVEL))
        .isRequired,
      quantity: PropTypes.number.isRequired,
    })
  ),
};

export default Summary;
